import React, { useState } from "react";
import RenderIcons from "../../../../Assets/css/_icons/partner_icon/RenderIcons";
import { DialogComponent } from "../../../common/DialogComponent";
import DarkWebFinancialAccountConfirmDeleteDialog from "../../../Dialogs/DarkWebFinancialAccountConfirmDeleteDialog";

interface IProps {
    monitorId: string | null;
    recordId: string;
    isMonitored: boolean;
    accountNumber: string;
    monitorType: number;
    monitorName: string;
    monitorDisplayName: string;
    onDelete: any;
    icon: string;
    id?: string
}

const DarkWebFinancialAccount: React.FunctionComponent<IProps> = (props) => {
    const [showDarkWebFinancialAccountDeleteConfirmDialog, setShowDarkWebFinancialAccountDeleteConfirmDialog] = useState(false);
    const closeDarkWebFinancialAccountDeleteConfirmDialog = () => {
        setShowDarkWebFinancialAccountDeleteConfirmDialog(false);
    };

    const handleDarkWebFinancialAccountDeleteConfirmDialog = (value: string): any => {
        if (value === "show") {
            setShowDarkWebFinancialAccountDeleteConfirmDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setShowDarkWebFinancialAccountDeleteConfirmDialog(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setShowDarkWebFinancialAccountDeleteConfirmDialog(false);
            props.onDelete();
        }
    };

    return (
        <React.Fragment>
            <div className="data-row row">
                <div className="col-xs-12 col-sm-6 col-no-gutter">
                    <div className="data-label" id={props.id ? `label-${props.id}` : "label-account"}>
                        {props.accountNumber}
                    </div>
                </div>
                <div className="col-xs-11 col-sm-5 col-no-gutter">
                    <div className="data-value has-gfx">
                        <span className="data-icon">
                            {props.monitorName.toLowerCase() === "bank account" ? (
                                <RenderIcons iconName="university" height="24" />
                            ) : (
                                <em className={"las la-" + props.icon}></em>
                            )}
                        </span>
                        {props.monitorDisplayName}
                    </div>
                </div>
                <div className="col-xs-1 col-sm-1 col-no-gutter flex-grow-null text-align-right">
                    <div className="data-value">
                        <button
                            type="button"
                            className="btn-default btn-secondary-outline btn-table btn-icon-only btn-no-border btn-no-padding btn-remove-item"
                            data-a11y-dialog-show="dialog-dark-web-financial-account-delete"
                            onClick={() => handleDarkWebFinancialAccountDeleteConfirmDialog("show")}
                            aria-label={props.monitorName === "Bank Account" ? "Remove Account" : "Remove Card" }
                        >
                            <span className="btn-icon">
                                <em className="las la-trash-alt"></em>
                            </span>
                            <span className="btn-text">{"Delete " + props.accountNumber}</span>
                        </button>
                    </div>
                </div>
            </div>

            {showDarkWebFinancialAccountDeleteConfirmDialog && (
                <DialogComponent
                    dialogId="dialog-dark-web-financial-account-delete"
                    title="Delete Account"
                    closeDialog={closeDarkWebFinancialAccountDeleteConfirmDialog}
                >
                    <DarkWebFinancialAccountConfirmDeleteDialog
                        monitorId={props.monitorId}
                        recordId={props.recordId}
                        accountOrCardNumber={props.accountNumber}
                        monitorType={props.monitorType}
                        closeDialog={handleDarkWebFinancialAccountDeleteConfirmDialog}
                    />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default DarkWebFinancialAccount;
